module.exports = __webpack_public_path__ + "img/75723E_C0C3A0_2A1E0E_AFAE77-256px.f3517025.png";